import styled from 'styled-components';

export const CartHeader = styled.header`
  width: 100%;
  max-width: 980px;

  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;

  gap: var(--space-xl) !important;

  margin-bottom: var(--space-xxl) !important;

  @media screen and (max-width: 700px) {
    flex-direction: column !important;

    gap: var(--space-l) !important;

    margin-bottom: var(--space-xl) !important;
  }
`;

export const CartHeaderContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: var(--space-s);

  flex: 1;

  h2 {
    max-width: 18ch;

    margin: 0;

    color: var(--grey7);

    font-size: clamp(2.35rem, 4.5vw, 4.25rem);
    font-weight: 800;
    line-height: 1.03;

    letter-spacing: -0.04em;

    text-align: left !important;

    @media screen and (max-width: 600px) {
      max-width: 100%;

      font-size: clamp(2.2rem, 11vw, 3.25rem);
      line-height: 1.04;
    }
  }
`;

export const Eyebrow = styled.p`
  margin: 0;

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1.4;

  text-transform: uppercase;
  letter-spacing: 0.14em;
`;

export const CartHeaderActions = styled.div`
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding-top: var(--space-xs);

  @media screen and (max-width: 700px) {
    width: 100%;

    justify-content: flex-start;

    padding-top: 0;
  }
`;
